import * as ScheduleStorageActionCreators from './schedule-storage-action';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    ...ScheduleStorageActionCreators
}

